'use strict';

function scrollToElement(element, options = {}) {
    var {center, offset, focus, disableScroll, duration, delay, scrollableParent} = options;
    setTimeout(() => {
        if (element && element.length) {
            if (element.length > 1) {
                element = element.eq(0);
            }
            var position = element.offset().top || 0;
            if (! position) {
                position = element.parent().length ? element.parent().offset().top : 0
            }

            if (center) {
                position -= window.innerHeight / 2;
            }

            if (offset) {
                position = position * offset;
            }
            
            if (disableScroll) {
                $('body').addClass('prevent-user-scroll');
            }

            if (! scrollableParent) {
                scrollableParent = $('html, body');
            }

            $(scrollableParent).animate(
                { scrollTop: position },
                {
                    duration: duration || 500,
                    complete: () => {
                        setTimeout(() => {
                            if (focus) {
                                element.focus();
                            }
                            if (disableScroll) {
                                $('body').removeClass('prevent-user-scroll');
                            }
                        }, 500);
                    }
                }
            );
        } else {
            $('.logo-home, .cc-logo-link').eq(0).focus();
        }
    }, delay || 0);
}


function scrollToPosition(position, options = {}) {
   var {center, disableScroll, duration, delay, scrollableParent} = options;
   setTimeout(() => {
        if (center) {
            position -= window.innerHeight / 2;
        }

        if (disableScroll) {
            $('body').addClass('prevent-user-scroll');
        }

        if (! scrollableParent) {
            scrollableParent = $('html, body');
        }

        $(scrollableParent).animate(
            { scrollTop: position || 0 },
            {
                duration: duration || 500,
                complete: () => {
                    if (disableScroll) {
                        setTimeout(() => {
                            $('body').removeClass('prevent-user-scroll'); 
                        }, 500);
                    }
                }
            }
        );
    }, delay || 0);
}

/**
 * Scrolls smoothly to an element or a position
 * @param {JQuery | number} elementOrPosition jquery element or position
 * @param {{
*      center: boolean,
*      offset: number,
*      focus: boolean,
*      disableScroll: boolean,
*      duration: number,
*      delay: number,
*      scrollableParent: JQuery
* }} options
*/
function scroll(elementOrPosition, options = {}) {
    if (typeof elementOrPosition === 'number') {
        var position = parseInt(elementOrPosition);
        scrollToPosition(position, options);
    } else {
        var element = elementOrPosition;
        if (! element instanceof jQuery) {
            element = $(element);
        }
        scrollToElement(element, options);
    }
}

module.exports = scroll;